var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HDSButton } from "@here/hds-react-components/Button";
import translations from "../../translations/resources/en-GB.json";
import indoormap from "../../assets/images/indoor_map.jpeg";
import "./noMapViewCard.scss";
export var tiles = [
    {
        primaryMessage: translations.data["venonboard.featureCard.featureHeadline.card1"],
        secondaryMessage1: translations.data["venonboard.featureCard.featureSubline.card1"],
        buttonDisplay: true,
        buttonText: translations.data["venonboard.featureCard.buttonText.card1"],
        buttonClickUrl: "https://platform.here.com/admin/apps",
    },
    {
        primaryMessage: translations.data["venonboard.featureCard.featureHeadline.card2"],
        secondaryMessage1: translations.data["venonboard.featureCard.featureSubline.card2"],
        buttonDisplay: true,
        buttonText: translations.data["venonboard.featureCard.buttonText.card2"],
        buttonClickUrl: "https://platform.here.com/sdk",
    },
    {
        primaryMessage: translations.data["venonboard.featureCard.featureHeadline.card3"],
        secondaryMessage1: translations.data["venonboard.featureCard.featureSubline.card3"],
    },
];
//Keeping the commented code in case we use a similar component later
// const NoMapViewCard = ({
//   primaryMessage = translations.data["venonboard.noMapViewCard.primaryMessage"],
//   secondaryMessage1 = translations.data[
//     "venonboard.noMapViewCard.secondaryMessage1"
//   ],
//   secondaryMessage2 = translations.data[
//     "venonboard.noMapViewCard.secondaryMessage2"
//   ],
//   subMessage = translations.data["venonboard.noMapViewCard.subMessage"],
//   buttonText = translations.data["venonboard.noMapViewCard.buttonText"],
// }: NoMapViewCard): JSX.Element => {
var NoMapViewCard = function () {
    // const iconStyle: keyValuePair = {
    //   "--hds-icon-color": "var(--hds-purple-600)",
    // };
    //const dispatch = useDispatch();
    return (_jsx("div", __assign({ className: "emptyBox" }, { children: _jsxs("div", __assign({ className: "noIndoorMapBox" }, { children: [_jsxs("div", __assign({ className: "noIndoorMapMessageContainer" }, { children: [_jsx("div", __assign({ className: "noIndoorMapTitle" }, { children: translations.data["venonboard.noIndoorMap.title"] })), _jsxs("div", __assign({ className: "noIndoorMapMessage" }, { children: [translations.data["venonboard.noIndoorMap.messagePart1"], " ", _jsx(HDSButton, __assign({ variant: "link", className: "noIndoorMapLink" }, { children: translations.data["venonboard.noIndoorMap.link"] })), " ", translations.data["venonboard.noIndoorMap.messagePart2"]] })), _jsx("div", __assign({ className: "noIndoorMapMessage" }, { children: translations.data["venonboard.noIndoorMap.messagePart3"] }))] })), _jsx("img", { "data-testid": "no-indoor-map", className: "indoormap", src: indoormap, alt: "indoormap", width: "330px", height: "230px" })] })) })));
};
export default NoMapViewCard;
